import fromAnyToString from 'utils/converters/fromAnyToString';

const REGEX_ALL_SALON_ID = /:salonId/g;

const replaceSalonId = (options) => {
  const path = fromAnyToString(options?.path);
  const salonId = fromAnyToString(options?.salonId) || ':salonId';

  return path.replace(REGEX_ALL_SALON_ID, salonId);
};

export default replaceSalonId;
